import React from "react";
import BaseSelect, { components } from "react-select";
import Icon from "./icon.svg";
import CloseIcon from "./close.svg";
import style from "./index.module.scss";
import useForm from "../Form/hooks/useForm";

export const styles = {
  control: (styles) => ({
    ...styles,
    borderColor: "#97ADC6",
    borderRadius: 8,
    color: "#181818",
    minHeight: 50,
    boxShadow: "none",
    cursor: "pointer",
    transform: "translate3d(0px,0px,0px)",
    ":hover": {
      borderColor: "#0084FF",
    },
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#97ADC6",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none",
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    width: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  menu: (styles) => ({
    ...styles,
    border: "1px solid #EDF3FF",
    boxShadow: "0px 14px 24px rgba(26, 53, 78, 0.15)",
    borderRadius: 8,
    overflow: "hidden",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
    ...styles,
    background: isFocused ? "#EDF3FF" : "inherit",
    color: "#181818",
  }),
  multiValue: (styles) => ({
    ...styles,
    background: "#EDF3FF",
    borderRadius: 6,
    display: "flex",
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: 8,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export function IndicatorsContainer(props) {
  return (
    <components.IndicatorsContainer {...props}>
      <Icon />
    </components.IndicatorsContainer>
  );
}

export function MultiValue(props) {
  return (
    <div className={`${style.multiValue}`}>
      <components.MultiValueRemove
        data={props.data}
        innerProps={props.removeProps}
        selectProps={props.selectProps}
      >
        <CloseIcon />
      </components.MultiValueRemove>
      <components.MultiValueLabel {...props} />
    </div>
  );
}

export function _Select(props) {
  return (
    <BaseSelect
      {...props}
      placeholder={`Select ${props.name.replace(/_/gi, " ")} `}
      styles={styles}
      components={{
        MultiValue,
        IndicatorsContainer: IndicatorsContainer,
      }}
    />
  );
}

export default function Select(props) {
  const [onChange, formData] = useForm();
  const value = formData[props.name];

  let _value;
  let valueToArr;
  if (value && Array.isArray(value) === false) {
    valueToArr = value.split(" ");
  }
  if (Array.isArray(valueToArr)) {
    _value = props.options.filter((e) => value.indexOf(e.value) !== -1);
  } else {
    _value = props.options.find((e) => e.value == value);
  }

  return (
    <_Select
      {...props}
      value={_value}
      onChange={(e) => {
        const value = props?.isMulti ? e.map((v) => v.value) : e?.value;
        onChange(value, props);
      }}
      styles={styles}
      components={{
        MultiValue,
        IndicatorsContainer: IndicatorsContainer,
      }}
    />
  );
}
